import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import App from './containers/App';
import Engage from './containers/Engage'


let Routes = () => {

  return (
    <div>

      <Switch>
        <Route exact path="/" component={App}/>
        <Route path="/engage" component={Engage}/>
        <Redirect to="/"/>
      </Switch>
    </div>
  );
};


export default  Routes;


// WEBPACK FOOTER //
// ./src/routes.js